import { render, staticRenderFns } from "./v-main-header.vue?vue&type=template&id=f3138f7a&scoped=true"
import script from "./v-main-header.vue?vue&type=script&lang=js"
export * from "./v-main-header.vue?vue&type=script&lang=js"
import style0 from "./v-main-header.vue?vue&type=style&index=0&id=f3138f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3138f7a",
  null
  
)

export default component.exports